import {StoreObject, Reference, FieldFunctionOptions} from '@apollo/client';

/**
 * Properties that help the getId function derive the ID.
 */
export interface GetIdOpts<T, U, V> {
  mergeObjects?: (a: V, b: V) => V | undefined;
  readField?: FieldFunctionOptions<T, U>['readField'];
  cache: FieldFunctionOptions<T, U>['cache'];
}

/**
 * Get the ID field from a normalized cached object or reference.
 */
export const getId = <T, U, V>(
  opts: GetIdOpts<T, U, V>,
  obj: StoreObject | Reference,
) => {
  // Note that there appears to be a bug that if the object hasn't been stored
  // in the cache yet, readField fails.
  let id = '';

  if (opts.readField) {
    id = opts.readField<string>('id', obj) || '';
  } else if (Object.hasOwn(obj, 'id')) {
    id = (obj as {id: string}).id || '';
  }

  if (!id) {
    const fullCacheId = opts.cache.identify(obj);
    id = fullCacheId?.split(':')[1] || '';
    if (!id) {
      throw new Error('Failed to get cache ID');
    }
  }
  return id;
};
